import { useDevices, useLocations } from "@repo/data-store";
import { createFileRoute, redirect } from "@tanstack/react-router";
import type { ActorSelection } from "@/features/scheduling";
import { ScheduleSettings } from "@/features/scheduling";

interface NewScheduleSearch {
  actorType?: string;
  actorId?: string;
  actorDisplay?: string;
}

export const Route = createFileRoute("/schedule/manage/new")({
  validateSearch: (search: Record<string, unknown>): NewScheduleSearch => ({
    actorType: search.actorType as string | undefined,
    actorId: search.actorId as string | undefined,
    actorDisplay: search.actorDisplay as string | undefined,
  }),
  beforeLoad: ({ context }) => {
    const { permissions } = context;

    if (!permissions.canRead("Schedule")) {
      throw redirect({ to: "/schedule", search: { view: "week" } });
    }
  },
  component: NewScheduleComponent,
});

function NewScheduleComponent() {
  const { profile } = Route.useRouteContext();
  const { locations } = useLocations();
  const { devices } = useDevices();
  const { actorType, actorId, actorDisplay } = Route.useSearch();

  const defaultActor: ActorSelection | undefined =
    actorType && actorId && (actorType === "Practitioner" || actorType === "Location" || actorType === "Device")
      ? { type: actorType, id: actorId, display: actorDisplay }
      : undefined;

  return (
    <ScheduleSettings
      allLocations={locations}
      allDevices={devices}
      mode="create"
      profile={profile}
      defaultActor={defaultActor}
    />
  );
}
